import { writable, type Writable } from 'svelte/store';
import { browser } from '$app/environment';

export interface ContactUsForm {
  email: string;
  message: string;
  phone: string;
  major: string;
  full_name: string;
  inquiry_type: string;
}

export enum ContactUsStep {
  First = 'first',
  Second = 'second',
  Success = 'success',
}

export type ContactUsLC = {
  step: ContactUsStep;
  form: ContactUsForm;
};

export interface CreateTheme extends Writable<ContactUsLC> {
  useLocalStorage: () => void;
}

const initialContactForm: ContactUsLC = {
  step: ContactUsStep.First,
  form: {
    email: '',
    message: '',
    phone: '',
    major: '',
    full_name: '',
    inquiry_type: '',
  },
};

export const contactUsKey = 'store-contact-us';

const createTheme = (key: typeof contactUsKey, initValue: ContactUsLC) => {
  const { set, subscribe, update }: Writable<ContactUsLC> = writable(initValue);

  return {
    subscribe,
    updateForm: (data: ContactUsForm) => {
      update((prev) => ({ ...prev, form: { ...prev.form, ...data } }));
    },
    updateStep: (step: ContactUsStep) => {
      update((prev) => ({ ...prev, step }));
    },
    reset: () => {
      set(initValue);
    },
    useLocalStorage() {
      if (!browser) return;

      const json = localStorage.getItem(key);

      if (json) {
        set(JSON.parse(json));
      }

      subscribe((current) => {
        localStorage.setItem(key, JSON.stringify(current));
      });
    },
  };
};

export const contactUsForm = createTheme(contactUsKey, initialContactForm);
